export { useDeleteCompanyGoal, useSaveCompanyGoal } from './api/growth-mutations';
export { useCompanyGoals } from './api/growth-queries';
export { GROWTH_GOAL_TILE_TYPE, GROWTH_NEW_GOAL_TILE_TYPE } from './tile-payloads';
export { growthUrlTileModule } from './url-tile';

export const growthRoute = {
    patterns: {
        growth: '/growth',
    },
} as const;

export const loadGrowthPage = async () => {
    const { GrowthPage } = await import('./GrowthPage');

    return { Component: GrowthPage };
};
